"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Semver__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "uint256",
                name: "major",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "minor",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "patch",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "version",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class Semver__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    getDeployTransaction(major, minor, patch, overrides) {
        return super.getDeployTransaction(major, minor, patch, overrides || {});
    }
    deploy(major, minor, patch, overrides) {
        return super.deploy(major, minor, patch, overrides || {});
    }
    connect(runner) {
        return super.connect(runner);
    }
    static bytecode = _bytecode;
    static abi = _abi;
    static createInterface() {
        return new ethers_1.Interface(_abi);
    }
    static connect(address, runner) {
        return new ethers_1.Contract(address, _abi, runner);
    }
}
exports.Semver__factory = Semver__factory;
//# sourceMappingURL=Semver__factory.js.map